import { render, staticRenderFns } from "./P2pFee.vue?vue&type=template&id=04ba8ef4&"
import script from "./P2pFee.vue?vue&type=script&lang=js&"
export * from "./P2pFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports